import { Route, Routes } from "react-router-dom";
import VaultIDPage from "../../app/vault/id";

export default function VaultRoutes() {
  return (
    <Routes>
      <Route path="*" element={<VaultIDPage />} />
    </Routes>
  );
}
